import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Colors } from '@lean-body/components/styles';
export const SearchFilterCircles = ({ items, onClick }) => {
    return (React.createElement("div", { className: css(styles.circles) }, items.map((item) => (React.createElement("div", { key: item.id, className: css(styles.circleItem), onClick: () => onClick(item.id) },
        React.createElement("img", { className: css(styles.circleImg, item.selected && styles.circleImgOn), src: item.imageUrl, alt: "", loading: "lazy", decoding: "async" }),
        React.createElement("span", { className: css(styles.label) }, item.name))))));
};
const styles = StyleSheet.create({
    circles: {
        display: 'grid',
        gridTemplateColumns: 'repeat(4, minmax(0, 96px))',
        justifyContent: 'center',
        columnGap: '8px',
        rowGap: '16px',
    },
    circleItem: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 4,
        fontSize: 12,
        cursor: 'pointer',
    },
    label: {
        width: '100%',
        textAlign: 'center',
        whiteSpace: 'pre-line',
    },
    circleImg: {
        width: '100%',
        maxWidth: 88,
        aspectRatio: '1',
        borderRadius: '50%',
        objectFit: 'cover',
        border: '2px solid transparent',
    },
    circleImgOn: {
        borderColor: Colors.PrimaryDark,
        boxShadow: `inset 0 0 0 100vmax ${Colors.PrimaryTransparentB}`,
    },
});
